module.exports = __webpack_public_path__ + "img/logo.5714d5f1.png";